<template>
    <b-col sm="12">
        <b-card no-body>
            <b-card-header>
                <span class="h6">
                    IRREGULARIDADES
                </span>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    :itens="irregularidades"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >

                    <template slot="situacao" slot-scope="data">
                        <app-status
                            :status="toUppercase(data)"
                        ></app-status>
                    </template>
                    <template slot="botoes">
                        <div class="float-right mr-1">
                            <b-button-group class="float-right">
                                <b-button
                                    variant="success"
                                    @click="abrirModalAssociacao()"
                                >Associar Irregularidade
                                </b-button>
                            </b-button-group>
                        </div>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span class="text-primary float-left mr-1">
                        <i 
                            class="fa fa-info-circle fa-lg icon-button"
                            title="Detalhar Irregularidade"
                            @click.stop="mostarDetalheIrregularidadeFiscalizacao(data)"
                        ></i>
                        </span>
                        <span v-if="data.situacao.toUpperCase() === 'NÃO FISCALIZADO - NÃO FISCALIZADO'" class="text-danger">
                            <i
                                class="fa fa-trash fa-lg icon-button"
                                title="Desassociar Irregularidade"
                                @click.stop="confirmarDesassociacao(data)"
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <b-modal v-model="mostrarModal" :hide-footer="!mostrarFormIrregularioFiscalizacao" @hide="esconderModalAssociacao()">
            <div slot="modal-title">
                Irregularidade -
                <b-badge variant="warning">Associação</b-badge>
            </div>
            <b-row >
                <b-col sm="12">
                    <b-form-group>
                        <model-list-select
                            :list="irregularidadesNaoAssociadas"
                            option-text="descricao"
                            option-value="idIrregularidade"
                            v-model="irregularidade"
                            placeholder="Selecione uma irregularidade"
                            @input="onSelecionarIrregularidade"
                        />
                        <b-form-invalid-feedback>A gradação é obrigatória</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="mostrarFormIrregularioFiscalizacao">
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição</label>
                        <b-input-group>
                            <b-form-textarea
                                v-model="descricao"
                                :rows="3"
                                :disabled="true"
                            ></b-form-textarea>
                            <b-form-invalid-feedback>A descrição é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="mostrarFormIrregularioFiscalizacao">
                <b-col sm="12">
                    <b-form-group>
                        <label>Gradação</label>
                        <b-form-input
                            type="text"
                            v-model="gradacao"
                            :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="mostrarFormIrregularioFiscalizacao">
                <b-col sm="12">
                    <b-form-group>
                        <label>Dias para correção</label>
                        <b-input-group>
                            <b-form-input
                                type="number"
                                v-model="quantidade"
                                :state="$v.quantidade.$error ? false : null"
                                @input.native="$v.quantidade.$touch()"
                            ></b-form-input>
                            <b-form-invalid-feedback>O campo é obrigatório e deve ser maior que zero.</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="esconderModalAssociacao()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvarIrregularidade()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </b-col>
</template>

<script>
import FiscalizacoesServicos from './FiscalizacoesServicos'
import { required, minValue } from 'vuelidate/lib/validators'
import { ModelListSelect } from 'vue-search-select'

export default {
    components: {
        ModelListSelect
    },

    props: {
        fiscalizacao: {
            type: Object,
            required: true
        },
        irregularidades: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true,
                },
                {
                    key: 'gradacao',
                    label: 'Gradação',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10,

            mostrarModal: false,
            mostrarFormIrregularioFiscalizacao: false,
            irregularidadesNaoAssociadas: [],
            irregularidade: null,
            descricao: '',
            quantidade: '',
            gradacao: ''
        }
    },
    methods: {        
        onSelecionarIrregularidade(idIrregularidade) {
            const selecionada = this.irregularidadesNaoAssociadas.find(ir => ir.idIrregularidade === idIrregularidade)

            if (selecionada) {
            this.descricao = selecionada.descricao
            this.quantidade = selecionada.diasParaCorrecao
            this.gradacao = selecionada.gradacao
            this.mostrarFormIrregularioFiscalizacao = true
            }
        },

        toUppercase(irregularidadeFiscalizacao) {
            let situacao = irregularidadeFiscalizacao.situacao
            return situacao ? situacao.toString().toUpperCase() : ""
        },
    
        mostarDetalheIrregularidadeFiscalizacao(data) {
            this.$emit('obterDetalheIrregularidadeFiscalizacao', data)
        },
    
        desassociarIrregularidadeFiscalizacao(idIrregularidade) {
            this.$store.dispatch('addRequest')
            FiscalizacoesServicos
                .desassociarIrregularidadeFiscalizacao(this.fiscalizacao.idFiscalizacao, idIrregularidade).then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('obterFiscalizacao')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarDesassociacao(irregularidadeAssociada) {
            this.$swal({
                title: 'Desassociação de Irregularidade',
                html: `Confirma a desassociação da irregularidade?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.desassociarIrregularidadeFiscalizacao(irregularidadeAssociada.idIrregularidade)
                }
            })
        },

        atualizarFiscalizacao() {
            this.$router.push({
                name: 'Fiscalizações_Atualizar',
                params: { fiscalizacaoId: this.$route.params.fiscalizacaoId }
            })
        },

        abrirModalAssociacao() {
            this.mostrarModal = true
            this.obterIrregularidadesNaoAssociadas()
        },

        onChangeIrregularidade(idIrregularidade) {
            this.$store.dispatch('addRequest')
            FiscalizacoesServicos.obterDadosIrregularidade(idIrregularidade).then(response => {
                if (response) {
                    if (response.success) {
                        this.preencherFormulario(response.data)
                    } else {
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        preencherFormulario(irregularidade) {
            this.descricao = irregularidade.descricao
            this.quantidade = irregularidade.diasParaCorrecao
            this.gradacao = irregularidade.gradacao
            this.mostrarFormIrregularioFiscalizacao = true
        },

        esconderModalAssociacao() {
            this.mostrarModal = false
            this.irregularidadesNaoAssociadas = [];
            this.irregularidade = null
            this.escricao = ''
            this.quantidade = ''
            this.gradacao =  ''
            this.mostrarFormIrregularioFiscalizacao = false
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        obterIrregularidadesNaoAssociadas() {
            this.$store.dispatch('addRequest')
            FiscalizacoesServicos.obterIrregularidadesDisponiveis(this.fiscalizacao.idFiscalizacao).then(response => {
                if (response) {
                    if (response.success) {
                        this.irregularidadesNaoAssociadas = response.data
                    } else {
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarSalvarIrregularidade() {
            this.$swal({
                title: 'Irregularidade',
                html: `Confirma a associação da irregularidade?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.associarIrregularidade()
                }
            })
        },

        associarIrregularidade() {
            this.$store.dispatch('addRequest')
            let idFiscalizacao = this.fiscalizacao.idFiscalizacao
            let idIrregularidade = this.irregularidade

            FiscalizacoesServicos.associarIrregularidade(idFiscalizacao, idIrregularidade, this.quantidade).then(response => {
                if (response) {
                    if (response.success) {
                        this.esconderModalAssociacao();
                        this.$toast.success(
                            'Registro salvo com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterFiscalizacao')
                    } else {
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    watch: {
    },

    validations: {
        quantidade: {
            required, 
            minValue: minValue(1)
        },
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },
    }
}
</script>